// Cascade-badge colour tiers (presentation only). Cascade testing badges use
// amber — the "action needed" register that matches the Recommended Actions
// sidebar cards (#ed6c02) — instead of purple, which elsewhere in TrakGene means
// genome/genotype data. A saturation gradient distinguishes prior-probability
// tiers; the % label inside the badge still carries the same information, so
// colour is never the sole signal.
//
// Thresholds are CLINICAL decisions (standard Mendelian inflection points), not
// design choices: 0.5 = first-degree relative of a confirmed carrier; 0.25 =
// conditional on an untested intermediate relative; below that = more distant /
// watch-only. Order matters: an explicit `defer` recommendation always wins.

export const PRIMARY_THRESHOLD = 0.5;
export const SECONDARY_THRESHOLD = 0.25;

// Keyed to the Recommended Actions amber (#ed6c02). White text/stroke kept by the
// renderer for legibility on all three.
export const CASCADE_BADGE_COLORS = Object.freeze({
  primary: '#ed6c02', // priorProbability >= 0.5
  secondary: '#f0a560', // 0.25 <= priorProbability < 0.5
  deferred: '#9a8b7e' // priorProbability < 0.25 OR recommendedAction === 'defer'
});

export function getCascadeBadgeTier(candidate) {
  if (!candidate) return 'deferred';
  if (candidate.recommendedAction === 'defer') return 'deferred';
  const prior = candidate.priorProbability || 0;
  if (prior >= PRIMARY_THRESHOLD) return 'primary';
  if (prior >= SECONDARY_THRESHOLD) return 'secondary';
  return 'deferred';
}
